"use strict";

export default function ($stateProvider) {
  "ngInject";
  $stateProvider.state("aptitude", {
    url: "/aptitude",
    template: "<aptitude></aptitude>",
  });
}
